import { render } from "./file.vue?vue&type=template&id=1d1e098c&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import "./file.vue?vue&type=style&index=0&id=1d1e098c&scoped=true&lang=css"

import exportComponent from "E:\\pay\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1e098c"]])

export default __exports__